import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Box,
    Card,
    Divider,
    Stack,
    Typography
} from '@mui/material';
// routes

// components
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { useVerifyShopFloorPasscodeMutation } from 'src/store/Reducer/shop-floor-display-settings';
import { enqueueSnackbar } from 'notistack';

// ----------------------------------------------------------------------

export default function PasscodeView({onFalse}) {

    const [ verifyShopFloorPasscode] = useVerifyShopFloorPasscodeMutation();

    const VerifySchema = Yup.object().shape({
        passcode: Yup.string()
            .required('Passcode is required')
            .min(6, 'Passcode must be at least 6 characters'),
    });

    const defaultValues = {
        passcode: '',
    };

    const methods = useForm({
        mode: 'onChange',
        resolver: yupResolver(VerifySchema),
        defaultValues,
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
    } = methods;


    const onSubmit = handleSubmit(async (data) => {
        try {
            let payloadData = {
                accessPasscode: data.passcode
            }
            const verifyResponse = await verifyShopFloorPasscode(payloadData)
            if(!verifyResponse?.error){
                enqueueSnackbar('Passcode verified successfully', { variant: 'success' });
                onFalse(false)
            }
        }catch (error) {
            console.error(error);
        }
    });

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
                py: 6,
            }}
        >
            <Card
                sx={{
                    width: 1,
                    maxWidth: 480,
                    p: 5,
                    borderRadius: 4,
                    boxShadow: (theme) => theme.customShadows?.z24,
                }}
            >
                <Stack spacing={3} alignItems="center" textAlign="center">
                    <Stack spacing={1}>
                        <Typography variant="h4">
                            Verify Passcode
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.secondary',
                                maxWidth: 320,
                                mx: 'auto',
                                lineHeight: 1.6,
                            }}
                        >
                            Enter the verification passcode to continue.
                        </Typography>

                    </Stack>
                </Stack>

                <Divider sx={{ my: 4 }} />

                <FormProvider methods={methods} onSubmit={onSubmit}>
                    <Stack spacing={3}>
                        <RHFTextField
                            name="passcode"
                            label="Passcode"
                            placeholder="Enter your passcode"
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                maxLength: 6,
                            }}
                        />

                        <LoadingButton
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            loading={isSubmitting}
                            sx={{
                                height: 52,
                                borderRadius: 2,
                                fontSize: 16,
                                fontWeight: 600,
                            }}
                        >
                            Verify Code
                        </LoadingButton>

                    </Stack>
                </FormProvider>
            </Card>
        </Box>
    );
}